<template>
    <div>
        <el-row :gutter="20">
            <h2 style="margin-top:unset;">Available Zipcode SCG</h2>
            <el-col :span="12" :offset="6">
                <el-card shadow="never" style="padding-bottom:20px;">
                    <el-row>
                        <el-col :span="6">
                            <el-input v-model="filters[0].value" type="number" placeholder="ค้นหารหัสไปรษณีย์"></el-input>
                        </el-col>
                        <el-col :span="6" style="margin-left:5px;">
                            <el-input v-model.number="zipcodeAdd" type="number" placeholder="เพิ่มรหัสไปรษณีย์"></el-input>
                        </el-col>
                        <el-col :span="6" style="margin-left:5px;text-align: left;">
                            <el-button type="primary" @click="addZipcode()" :disabled="String(this.zipcodeAdd).length !== 5">บันทึก</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <data-tables
                            :data="sortingList"
                            :filters="filters"
                            class="dataTable"
                            :page-size="10"
                            :pagination-props="{ pageSizes: [10, 20, 50, 100], pagerCount: 5 }">
                            <el-table-column label="รหัสไปรษณีย์" prop="zipcode" width="250">
                            </el-table-column>
                            <el-table-column label="ลบ" prop="zipcode" width="250">
                                <div class="text-md-left" slot-scope="scope">
                                    <el-button type="danger" icon="el-icon-delete" circle @click="onDelete(scope.$index,scope.row.zipcode)"></el-button>
                                </div>
                            </el-table-column>
                        </data-tables>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'AvailableZipcodeSCG',
    data () {
        return {
            zipcodeROw: null,
            sortingList: [],
            filters: [
                { prop: 'zipcode', value: '' }
            ],
            zipcodeAdd: null
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        async fetchData () {
            this.sortingList = []
            this.sortingRaw = {}
            try {
                let res = await fgApi.courier.getAvailableZipcode({ courier_provider_id: 1 })
                // console.log(res)
                // this.sortingRaw = res.assertCode
                this.zipcodeROw = [...res.data.availableZipcode]
                res.data.availableZipcode.forEach(e => {
                    this.sortingList.push({
                        zipcode: e
                    })
                })
                // console.log(this.sortingList)
            } catch (error) {
                console.log(error)
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
        },
        async addZipcode () {
            if (this.zipcodeROw.indexOf(parseInt(this.zipcodeAdd)) === -1) {
                this.zipcodeROw.unshift(this.zipcodeAdd)
                let param = {
                    courier_provider_id: 1,
                    available_zipcode: [...this.zipcodeROw]
                }
                try {
                    let res = await fgApi.courier.updateAvailableZipcode(param)
                    if (res.success) {
                        this.fetchData()
                        this.zipcodeAdd = ''
                        this.$notify({
                            title: 'Success',
                            message: 'Update Success',
                            type: 'success'
                        })
                    }
                } catch (error) {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    })
                }
            } else {
                this.$notify({
                    title: 'Warning',
                    message: 'Zipcode ซ้ำ',
                    type: 'warning'
                })
            }
        },
        onDelete (index, zipcode) {
            this.$confirm('จะลบละนะ ?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$confirm('จะลบจริงๆละนะ ?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                    customClass: 'deleteZipcode'
                }).then(async () => {
                    this.zipcodeROw.splice(this.zipcodeROw.indexOf(zipcode), 1)
                    let param = {
                        courier_provider_id: 1,
                        available_zipcode: [...this.zipcodeROw]
                    }
                    try {
                        let res = await fgApi.courier.updateAvailableZipcode(param)
                        if (res.success) {
                            this.fetchData()
                            this.zipcodeAdd = ''
                            this.$notify({
                                title: 'Success',
                                message: 'Delete Success',
                                type: 'success'
                            })
                        }
                    } catch (error) {
                        this.$notify.error({
                            title: 'Error',
                            message: error
                        })
                    }
                }).catch(() => {})
            }).catch(() => {})
        }
    }
}
</script>

<style lang="scss">
.deleteZipcode{
    .el-message-box__content{
        padding: 50px 15px;
        font-size: 20px;
    }

}
</style>
